/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Headline = 'Website.ProductReview.ReviewReport.ReviewReportQuickView.Headline';
export const Description = 'Website.ProductReview.ReviewReport.ReviewReportQuickView.Description';
export const Dismiss = 'Website.ProductReview.ReviewReport.ReviewReportQuickView.Dismiss';
